import { IDynamicTabLink } from '../interfaces/dynamic-tab.interface';

export const APPROVALS_TABS_CONSTANT: IDynamicTabLink[] = [
  {
    to: (slug?: string) => `/approvals/${slug}/information`,
    label: 'Information',
  },
  { to: (slug?: string) => `/approvals/${slug}/signatory-remarks`, label: 'Clearance Form' },
];
